import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@ublend-npm/aulaui-next-web/Menu';
import { SortType, SortListItem } from './SortParticipants.styled';
import sortIcon from './sort-participants-icon.svg';
import TextButton from '../../../common/Buttons/TextButton';

const sortTypes = {
  lastName: {
    name: 'Last name',
    key: 'lastName',
    selected: (value) => value === 'lastName',
  },
  role: {
    name: 'Role',
    key: 'role',
    selected: (value) => value === 'role',
  },
};

const SortParticipants = ({ fetchParticipants, sortBy, changeSortType }) => {
  const handleClick = async (sortType) => {
    changeSortType(sortTypes[sortType].key);
    await fetchParticipants(sortType, true);
  };

  return (
    <Menu
      ariaLabelledby="menu_feed"
      renderTarget={({ handleTargetClick }) => (
        <SortType onClick={handleTargetClick}>
          <TextButton
            label={
              <>
                <span>{sortTypes[sortBy].name}</span>
                <span>
                  <img src={sortIcon} alt="No spaces" width={20} height={20} />
                </span>
              </>
            }
          />
        </SortType>
      )}
      onSelect={({ item }) => item()}
      renderChildren={({ getItemProps }) =>
        Object.keys(sortTypes).map((type) => (
          <SortListItem
            key={sortTypes[type].key}
            tabIndex={0}
            highlighted={sortTypes[type].selected(sortBy)}
            primaryText={sortTypes[type].name}
            {...getItemProps({
              item: () => handleClick(sortTypes[type].key),
              onClick: (e) => e.stopPropagation(),
            })}
          />
        ))
      }
    />
  );
};

SortParticipants.propTypes = {
  sortBy: PropTypes.string.isRequired,
  fetchParticipants: PropTypes.func.isRequired,
  changeSortType: PropTypes.func.isRequired,
};

export default SortParticipants;
